/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { useSubmissionLock } from '../../redux/features/submission/useSubmissionLock';

/**
 * Generic component that loads generic hooks related to submission(s)
 */
export const SubmissionHooks = ({ children }) => {
  useSubmissionLock();

  return children;
};
